module.exports = __webpack_public_path__ + "static/cosi0s-c77dda61b1e6d3e87ef007ce198cbb4f.jpg";